import Vue from 'vue'
import {helpers} from './../../helpers';

export default {
    store: {
        namespaced: true,
        state: {
            endpoint: 'stock',
            stocks: [],
            printers: [],
            responsibles: [],
            freights: [],
            freight: {},
            freightsSearch: [],
            stock: {},
            itineraryFreight: [],
            itineraries: [],
            currentItinerary: {}
        },
        mutations: {
            changeItineraryFreight(state, val) {
                state.itineraryFreight = Object.assign([], val);
            },
            setCurrentItinerary(state, val) {
                state.currentItinerary = Object.assign({}, val);
            }
        },
        actions: {
            saveItinerary({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/itinerary', data);
            },
            
            removeItinerary({ rootState }, data) {
                return helpers.http.delete({context: this, rootState}, '/deals/itinerary', data);
            },
            
            deleteItinerary({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/route_list/' + id);
            },

            getItinerary({ rootState }) {
                return helpers.http.get({context: this, rootState}, '/deals/itinerary');
            },

            getPrinters({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/stock/printer', {params: data}).then(r => {
                    Vue.set(state, 'printers', r.data);
                    Vue.set(state, 'printers_amount', r.total);
                    return r;
                });
            },
            getPrinter({ state, rootState }, data) {
                return helpers.http.get({context: this, rootState}, '/stock/printer/byid/' + data.id, data).then(r => {
                    Vue.set(state, 'printer', r);
                    return r;
                });
            },
            putPrinter({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/stock/printer', data);
            },
            postPrinter({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/stock/printer', data);
            },
            removePrinter({ rootState }, stock_id) {
                return helpers.http.delete({context: this, rootState}, '/stock/printer/byid/' + stock_id);
            },

            getFromStocks({ state, rootState }) {
                return Vue.http.get(rootState.endpoint + '/stock', {params: {cache: true}}).then(response => {
                    Vue.set(state, 'from_stocks', response.body.response.data || response.body.response);
                    Vue.set(state, 'from_stocks_amount', response.body.response.total);
                    this.commit('hideProgressBar');
                    return response;
                });
            },
            getToStocks({ state, rootState }) {
                return helpers.http.get({context: this, rootState}, '/stock', {params: {all: true, cache: true}}).then(r => {
                    if (r && r.data) {
                        Vue.set(state, 'to_stocks', r.data);
                        Vue.set(state, 'to_stocks_amount', r.total);
                    } else if (r && Array.isArray(r)) Vue.set(state, 'to_stocks', r);
                    return r;
                });
            },
            getStocks({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/stock', {params: data}).then(r => {
                    if (!r || !r.data) return null;
                    Vue.set(state, 'stocks', r.data);
                    Vue.set(state, 'stocks_amount', r.total);
                    return r;
                });
            },
            getStock({ state, rootState }, data) {
                return helpers.http.get({context: this, rootState}, '/stock/byid/' + data.id, data).then(r => {
                    Vue.set(state, 'stock', r);
                    return r;
                });
            },
            putStock({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/stock', data);
            },
            postStock({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/stock', data);
            },
            removeStock({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/stock/byid/' + id);
            },
            getStockResponsibles({ state, rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/stock/byid/' + id + '/responsibles').then(r => {
                    Vue.set(state, 'responsibles', r);
                    return r;
                });
            },
            getStockResponsiblesFilter({ state, rootState }, data) {
                let params = {};
                if (data.groups && data.groups.length) params.groups = data.groups;

                return helpers.http.get({context: this, rootState}, '/stock/byid/' + data.id + '/responsibles', {params: params}).then(r => {
                    Vue.set(state, 'responsibles', r);
                    return r;
                });
            },

            getStockZones({ rootState }, id) {
                return helpers.http.get({context: this, rootState}, `/stock/byid/${id}/zones`);
            },
            addZoneToStock({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, `/stock/byid/${data.stock_id}/zones/${data.zone_id}`, { debug: true });
            },
            deleteZoneToStock({ rootState }, data) {
                return helpers.http.delete({context: this, rootState}, `/stock/byid/${data.stock_id}/zones/${data.zone_id}`, { debug: true });
            },

            getCityResponsibles({ state, rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/city/byid/' + id + '/responsibles').then(response => {
                    Vue.set(state, 'responsibles', response.body.response);
                    return response.body.response;
                });
            },
            getFreights({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals/freight', {params: data}).then(async r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'freights', r.data);
                    Vue.set(state, 'freights_amount', r.total);
                    return r.data;
                });
            },
            searchFreights({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals/freight', {params: data}).then(r => {
                    if (!r || !r.data) return null;
                    Vue.set(state, 'freightsSearch', r.data);
                    return r;
                });
            },
            getFreight({ state, rootState }, freightId) {
                return helpers.http.get({context: this, rootState}, '/deals/freight/byid/' + freightId).then(r => {
                    Vue.set(state, 'freight', r);
                    return r;
                });
            },
            getFreightTracking({ rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals/tracking', {params: data});
            },
            addFreightTracking({ rootState }, tracking) {
                return helpers.http.post({context: this, rootState}, '/deals/tracking', tracking);
            },
            updateFreightTracking({ rootState }, tracking) {
                return helpers.http.put({context: this, rootState}, '/deals/tracking', tracking);
            },
            getFreightTrackingById({ rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/deals/tracking/byid/' + id);
            },
            deleteFreightTracking({ rootState }, options) {
                return helpers.http.delete({context: this, rootState}, '/deals/tracking/byid/' + options.id);
            },
            getTrackingStatuses({ state, dispatch, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals/tracking_status', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'freight_statuses', r.data);
                    Vue.set(state, 'freight_statuses_amount', r.total);
                    return r.data;
                });
            },
            addTrackingStatus({ rootState }, trackingStatus) {
                return helpers.http.post({context: this, rootState}, '/deals/tracking_status', trackingStatus);
            },
            updateTrackingStatus({ rootState }, trackingStatus) {
                return helpers.http.put({context: this, rootState}, '/deals/tracking_status', trackingStatus);
            },
            getTrackingStatus({ rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/deals/tracking_status/byid/' + id);
            },
            deleteTrackingStatus({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/deals/tracking_status/byid/' + id);
            },
            getCities({ rootState }, data) {
                data = {filter: [["name", "%", data.name]]};
                return helpers.http.get({context: this, rootState}, '/city', {params: data});
            },
            getCity({ rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/city/' + id);
            },
            getZones({ rootState }, data) {
                data = {filter: [["name", "=%", data.name ]]};
                return helpers.http.get({context: this, rootState}, '/zone', {params: data});
            },
            attachUser({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/stock/user', {user_id: data.userId, stock_id: data.stockId });
            },
            detachUser({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/stock/user', {user_id: data.userId, stock_id: data.stockId, '_method': 'delete'});
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/stock/store.js